import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  //holdToken: null,
  seats: [],
  openDetails: false,
  //totalPrice: 0,
};

const reservationsCartSlice = createSlice({
  name: 'reservationsCart',
  initialState: initialState,
  reducers: {
    addSeat: (state, action) => {
      let seat = { ...action.payload };
      state.seats.push(seat);
    },

    removeSeat: (state, action) => {
      const { id: idToRemove, typeId: typeIdToRemove } = action.payload;

      const findFunc = typeIdToRemove
        ? ({ id, typeId }) => idToRemove === id && typeIdToRemove === String(typeId)
        : ({ id }) => idToRemove === id;

      const idx = state.seats.findIndex(findFunc);

      if (idx !== -1) {
        state.seats.splice(idx, 1);
      }
    },

    clearSeats: (state) => {
      state.seats = [];
      //state.totalPrice = 0;
      state.openDetails = false;
    },

    setOpenDetails: (state, action) => {
      state.openDetails = action.payload;
    },
  },
});

export const { addSeat, removeSeat, clearSeats, setOpenDetails } = reservationsCartSlice.actions;

export default reservationsCartSlice.reducer;
